import React, { useState } from 'react';
import '../styles/Subscription.css';

const Subscription = () => {
  const [isYearly, setIsYearly] = useState(true);

  // Mock data for Billing History
  const billingHistory = [
    { id: "INV-2025-0012", date: "20 May 2025", amount: "₹14,388", status: "Paid" },
    { id: "INV-2024-0011", date: "20 May 2024", amount: "₹14,388", status: "Paid" },
    { id: "INV-2023-0010", date: "20 May 2023", amount: "₹11,988", status: "Paid" },
    { id: "INV-2022-0009", date: "20 May 2022", amount: "₹11,988", status: "Paid" },
  ];

  return (
    <div className="sub-wrapper">
      <div className="sub-layout-grid">
        
        {/* LEFT COLUMN: Pricing & Usage */}
        <div className="sub-left-col">
          
          {/* Header & Toggle */}
          <div className="sub-header-row">
            <div>
              <h2 className="sub-page-title">Choose the perfect plan for your business</h2>
              <p className="sub-page-desc">Upgrade or downgrade your plan anytime. All plans include 7-day free trial.</p>
            </div>
            <div className="sub-toggle-container">
              <span className={`sub-toggle-label ${!isYearly ? 'sub-fw-600' : ''}`}>Monthly</span>
              <label className="sub-switch">
                <input type="checkbox" checked={isYearly} onChange={() => setIsYearly(!isYearly)} />
                <span className="sub-slider"></span>
              </label>
              <span className={`sub-toggle-label ${isYearly ? 'sub-fw-600' : ''}`}>Yearly</span>
              <span className="sub-badge-green-light sub-ml-10">Save up to 20%</span>
            </div>
          </div>

          {/* Pricing Cards Grid */}
          <div className="sub-pricing-grid">
            
            {/* Starter Plan */}
            <div className="sub-card sub-plan-card">
              <h3 className="sub-plan-title">Starter</h3>
              <p className="sub-plan-desc">Perfect for small businesses getting started.</p>
              <div className="sub-plan-price">
                <strong>₹599</strong><span>/month</span>
              </div>
              <div className="sub-plan-billed">Billed yearly ₹7,188</div>
              <button className="sub-btn-outline sub-w-full sub-mb-24">Choose Plan</button>
              <ul className="sub-feature-list">
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Up to 2 Users</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> 500 Invoices / Month</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> 500 Customers</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Inventory Management</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Email Support</li>
                <li className="sub-text-muted"><i className="fa-solid fa-circle-minus"></i> Basic Reports</li>
              </ul>
            </div>

            {/* Professional Plan (Active) */}
            <div className="sub-card sub-plan-card sub-plan-active">
              <div className="sub-plan-header-flex">
                <h3 className="sub-plan-title">Professional</h3>
                <span className="sub-badge-blue-light">Most Popular</span>
              </div>
              <p className="sub-plan-desc">Advanced features for growing businesses.</p>
              <div className="sub-plan-price">
                <strong>₹1,199</strong><span>/month</span>
              </div>
              <div className="sub-plan-billed">Billed yearly ₹14,388</div>
              <button className="sub-btn-primary sub-w-full sub-mb-24">Current Plan</button>
              <ul className="sub-feature-list">
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Up to 10 Users</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> 5,000 Invoices / Month</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Unlimited Customers</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Inventory & Warehouse</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> GST & Tax Reports</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Priority Support</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Advanced Reports</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Data Export</li>
              </ul>
            </div>

            {/* Business Plan */}
            <div className="sub-card sub-plan-card">
              <h3 className="sub-plan-title">Business</h3>
              <p className="sub-plan-desc">For established businesses with advanced needs.</p>
              <div className="sub-plan-price">
                <strong>₹1,999</strong><span>/month</span>
              </div>
              <div className="sub-plan-billed">Billed yearly ₹23,988</div>
              <button className="sub-btn-outline sub-w-full sub-mb-24">Choose Plan</button>
              <ul className="sub-feature-list">
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Up to 25 Users</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> 20,000 Invoices / Month</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Unlimited Customers</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Multi Warehouse</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Advanced GST & Tax</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Priority Support</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Advanced Reports</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Custom Roles</li>
              </ul>
            </div>

            {/* Enterprise Plan */}
            <div className="sub-card sub-plan-card">
              <h3 className="sub-plan-title">Enterprise</h3>
              <p className="sub-plan-desc">For large businesses with custom requirements.</p>
              <div className="sub-plan-price">
                <strong>Custom</strong>
              </div>
              <div className="sub-plan-billed">Tailored for your business</div>
              <button className="sub-btn-outline sub-w-full sub-mb-24">Contact Sales</button>
              <ul className="sub-feature-list">
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Unlimited Users</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Unlimited Invoices</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Unlimited Customers</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Advanced Security</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Custom Integrations</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> Dedicated Account Manager</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> 24/7 Support</li>
                <li><i className="fa-solid fa-circle-check sub-text-green"></i> SLA & Priority Services</li>
              </ul>
            </div>

          </div>

          {/* Usage Section */}
          <div className="sub-card sub-usage-section">
            <div className="sub-usage-header">
              <div>
                <h3 className="sub-card-title">Your Plan Usage</h3>
                <p className="sub-card-sub">Track your usage and limits for the current billing cycle.</p>
              </div>
              <div className="sub-text-sm sub-text-muted">Usage Period: 20 May 2025 - 20 Jun 2025</div>
            </div>

            <div className="sub-usage-grid">
              
              {/* Users */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-blue-light"><i className="fa-solid fa-users sub-text-blue"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">Users</span>
                    <strong className="sub-uc-val">6 <span className="sub-uc-limit">/ 10 Users</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-blue" style={{width: '60%'}}></div></div>
                  <span className="sub-progress-text">60% used</span>
                </div>
              </div>

              {/* Invoices */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-blue-light"><i className="fa-solid fa-file-invoice sub-text-blue"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">Invoices</span>
                    <strong className="sub-uc-val">2,350 <span className="sub-uc-limit">/ 5,000 Invoices</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-blue" style={{width: '47%'}}></div></div>
                  <span className="sub-progress-text">47% used</span>
                </div>
              </div>

              {/* Customers */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-green-light"><i className="fa-solid fa-user-check sub-text-green"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">Customers</span>
                    <strong className="sub-uc-val">1,280 <span className="sub-uc-limit">/ Unlimited</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-green" style={{width: '100%'}}></div></div>
                  <span className="sub-progress-text">Unlimited</span>
                </div>
              </div>

              {/* Storage */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-blue-light"><i className="fa-solid fa-cloud sub-text-blue"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">Storage</span>
                    <strong className="sub-uc-val">12.4 GB <span className="sub-uc-limit">/ 50 GB</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-blue" style={{width: '24%'}}></div></div>
                  <span className="sub-progress-text">24% used</span>
                </div>
              </div>

              {/* API Requests */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-blue-light"><i className="fa-solid fa-code sub-text-blue"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">API Requests</span>
                    <strong className="sub-uc-val">8,540 <span className="sub-uc-limit">/ 50,000</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-blue" style={{width: '17%'}}></div></div>
                  <span className="sub-progress-text">17% used</span>
                </div>
              </div>

              {/* Email Credits */}
              <div className="sub-usage-card">
                <div className="sub-uc-top">
                  <div className="sub-uc-icon sub-bg-blue-light"><i className="fa-regular fa-envelope sub-text-blue"></i></div>
                  <div className="sub-uc-info">
                    <span className="sub-uc-label">Email Credits</span>
                    <strong className="sub-uc-val">3,200 <span className="sub-uc-limit">/ 10,000</span></strong>
                  </div>
                </div>
                <div className="sub-progress-wrapper">
                  <div className="sub-progress-track"><div className="sub-progress-fill sub-bg-blue" style={{width: '32%'}}></div></div>
                  <span className="sub-progress-text">32% used</span>
                </div>
              </div>

            </div>

            {/* Banner */}
            <div className="sub-info-banner">
              <div className="sub-banner-left">
                <i className="fa-solid fa-circle-info sub-text-blue"></i>
                <span><strong>Need more?</strong> You can upgrade your plan to get higher limits and more features.</span>
              </div>
              <button className="sub-btn-outline-sm">Upgrade Plan</button>
            </div>
            
            <div className="sub-footer-note">All prices are exclusive of applicable taxes.</div>
          </div>

        </div>

        {/* RIGHT COLUMN: Sidebars */}
        <div className="sub-right-col">
          
          {/* Current Plan Card */}
          <div className="sub-card sub-p-24">
            <div className="sub-flex-between sub-mb-24">
              <h3 className="sub-card-title">Current Plan</h3>
              <span className="sub-badge-purple-light">Professional</span>
            </div>
            <div className="sub-cp-info">
              <div className="sub-cp-icon"><i className="fa-solid fa-crown"></i></div>
              <div>
                <strong>Professional Plan</strong>
                <span>Billed yearly</span>
              </div>
            </div>
            <div className="sub-divider"></div>
            <div className="sub-flex-between sub-mb-16">
              <span className="sub-text-muted sub-text-sm">Next Billing Date</span>
              <div className="sub-text-right">
                <strong className="sub-fw-600 sub-text-sm">20 Jun 2025</strong><br/>
                <span className="sub-text-muted sub-text-xs">(28 days left)</span>
              </div>
            </div>
            <div className="sub-flex-between sub-mb-24">
              <span className="sub-text-muted sub-text-sm">Amount</span>
              <strong className="sub-fw-600 sub-text-sm">₹14,388 / year</strong>
            </div>
            <button className="sub-btn-primary sub-w-full sub-mb-12">Upgrade Plan</button>
            <button className="sub-btn-outline sub-w-full">Manage Plan</button>
          </div>

          {/* Billing Information Card */}
          <div className="sub-card sub-p-24">
            <div className="sub-flex-between sub-mb-20">
              <h3 className="sub-card-title">Billing Information</h3>
              <a href="#" className="sub-link">Update</a>
            </div>
            <ul className="sub-details-list">
              <li><span className="sub-label">Business Name</span> <strong className="sub-val">Green Mart</strong></li>
              <li><span className="sub-label">GSTIN</span> <strong className="sub-val">27ABCDE1234F1Z5</strong></li>
              <li><span className="sub-label">Billing Email</span> <strong className="sub-val">billing@greenmart.com</strong></li>
              <li><span className="sub-label">Payment Method</span> <strong className="sub-val"><i className="fa-brands fa-cc-visa sub-text-blue"></i> •••• 4242</strong></li>
              <li className="sub-align-top"><span className="sub-label">Address</span> <strong className="sub-val">123, MG Road, Pune,<br/>Maharashtra - 411001</strong></li>
              <li><span className="sub-label">Invoice Preference</span> <strong className="sub-val">Receive invoice on email</strong></li>
            </ul>
          </div>

          {/* Billing History Card */}
          <div className="sub-card sub-p-24">
            <div className="sub-flex-between sub-mb-20">
              <h3 className="sub-card-title">Billing History</h3>
              <a href="#" className="sub-link">View All</a>
            </div>
            <div className="sub-table-wrapper">
              <table className="sub-table">
                <thead>
                  <tr>
                    <th>Invoice ID</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {billingHistory.map((row, i) => (
                    <tr key={i}>
                      <td className="sub-text-muted">{row.id}</td>
                      <td>{row.date}</td>
                      <td className="sub-fw-600">{row.amount}</td>
                      <td><span className="sub-badge-green">Paid</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="sub-mt-16">
              <a href="#" className="sub-link sub-flex-center"><i className="fa-solid fa-download sub-mr-8"></i> Download All Invoices</a>
            </div>
          </div>

          {/* Need Help Card */}
          <div className="sub-card sub-p-24">
            <h3 className="sub-card-title sub-mb-20">Need Help?</h3>
            <div className="sub-help-list">
              <a href="#" className="sub-help-item">
                <div className="sub-hi-icon"><i className="fa-regular fa-copy"></i></div>
                <div className="sub-hi-text">
                  <strong>View Plans & Features</strong>
                  <span>Compare all features in detail</span>
                </div>
                <i className="fa-solid fa-chevron-right sub-text-muted"></i>
              </a>
              <a href="#" className="sub-help-item">
                <div className="sub-hi-icon"><i className="fa-regular fa-circle-question"></i></div>
                <div className="sub-hi-text">
                  <strong>Payment & Billing FAQ</strong>
                  <span>Get answers to common questions</span>
                </div>
                <i className="fa-solid fa-chevron-right sub-text-muted"></i>
              </a>
              <a href="#" className="sub-help-item">
                <div className="sub-hi-icon"><i className="fa-solid fa-headset"></i></div>
                <div className="sub-hi-text">
                  <strong>Contact Support</strong>
                  <span>We're here to help you</span>
                </div>
                <i className="fa-solid fa-chevron-right sub-text-muted"></i>
              </a>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Subscription;